import { CategoryMenu } from './CategoryMenu'
import { withCategoryMenu } from './withCategoryMenu'

const ConnectedCategoryMenu = withCategoryMenu(CategoryMenu)
export { ConnectedCategoryMenu as CategoryMenu }
